import React from 'react';
import '../styles/Header.css';

const Header = () => {
  return (
    <header className="app-header">
      <div className="header-content">
        <div className="logo-container">
          <div className="hamburger-lines">
            {Array(12).fill().map((_, i) => (
              <div key={i} className="hamburger-line"></div>
            ))}
          </div>
          <div className="logo-text">
            <div className="logo-title">NATIONAL MUSEUM</div>
            <div className="logo-subtitle">
              <span className="of">OF</span> 
              <span className="the">THE</span> 
              <span className="pacific-war">PACIFIC WAR</span>
            </div>
          </div>
        </div>
        
        <h1 className="app-title">Society of Sons and Daughters of WWII Veterans Application</h1>
      </div>
    </header>
  );
};

export default Header; 